import React, { useEffect, useRef } from 'react';
import { useRouter } from 'next/router';

import { SplashLoader } from '~/domains/common/components/SplashLoader/SplashLoader';
import { Routes } from '~/domains/common/constants/routes';

const withCreateContestRedirect = <P extends object>(WrappedComponent: React.ComponentType<P>) => {
  function WithCreateContestRedirect(props: P) {
    const router = useRouter();
    const hasRedirectedRef = useRef(false);
    const { leagueId, contestTemplateId } = router.query;
    const shouldRedirect = router.isReady && !leagueId && !contestTemplateId;

    useEffect(() => {
      if (!shouldRedirect || hasRedirectedRef.current) {
        return;
      }

      hasRedirectedRef.current = true;
      // Same parent domain (.splashsports.com) — the session cookie carries across,
      // so no single-use token is needed.
      window.location.replace(Routes.createAContestExternalUrl());
    }, [shouldRedirect]);

    if (!router.isReady || shouldRedirect) {
      return <SplashLoader />;
    }

    return <WrappedComponent {...props} />;
  }

  WithCreateContestRedirect.displayName = `withCreateContestRedirect(${
    WrappedComponent.displayName || WrappedComponent.name
  })`;

  return WithCreateContestRedirect;
};

export default withCreateContestRedirect;
